export default __webpack_public_path__ + "static/media/eauchaud.cf8c948f.jpg";